/**
 * Format shopify price to decimal number
 * @param price
 * @returns {number}
 */
function formatPrice(price) {
    const reversed = price.toString().split('').reverse();
    const float = reversed.slice(0, 2)
    const decimals = reversed.slice(2)
    const res = `${decimals.reverse().join('')}.${float.reverse().join('')}`
    return Number(res);
}

/**
 * Format number price.
 * If price has decimal, use 2 decimal places. If is whole number, no decimal places are added
 * @param price {number}
 */
function formatPriceWithoutTrailingZeros(price) {
  return (price % 1) > 0 ? price.toFixed(2) : price.toString();
}

/**
 *
 * @param {number} price
 * @param {Priceadjustment | undefined} priceAdjustment
 */
function getProductPrice(price, priceAdjustment) {
    if (!priceAdjustment) {
        return formatPrice(price);
    }
    const formattedPrice = formatPrice(price);
    const formattedValue = formatPrice(priceAdjustment.value);
    switch (priceAdjustment.value_type) {
        case 'fixed_amount':
            return formattedPrice - formattedValue;
        case 'price':
            return formattedValue;
        case 'percentage':
            const value = Number(priceAdjustment.value)
            const discountAmount = (value / 100) * formattedPrice;
            return Number((formattedPrice - discountAmount).toFixed(2));
    }
}
